const NamasteDoctorBanner = ()=>{

  return (
    <div className="w-full app-top-mg app-side-pd bg-none">
      <img src="/images/namaste_banner.png" alt="Namaste Doctor" className="app-rounded w-full"/>
    </div>
  );
}

export default NamasteDoctorBanner;